import { Controller } from 'stimulus';

export default class extends Controller {
  selectLocation(event) {
    const button = event.currentTarget;
    const locationId = button.dataset.locationId;
    const select = document.getElementById('cp-filter-location-id');
    const form = document.getElementById('circularity-pot-filters');
    if (!select || !form) return;

    select.value = locationId || '';
    form.requestSubmit();
  }

  toggleAccordion(event) {
    const row = event.target.closest('tr[data-accordion-row]');
    if (!row) return;
    if (event.target.closest('a')) return;

    event.preventDefault();
    this.togglePanel(row.getAttribute('data-panel-id'), row);
  }

  toggleSourceItem(event) {
    const button = event.currentTarget;
    if (event.target.closest('a')) return;

    event.preventDefault();
    this.togglePanel(button.getAttribute('data-panel-id'), button);
  }

  togglePanel(panelId, controlEl) {
    const panel = document.getElementById(panelId);
    if (!panel || !controlEl) return;

    const isOpen = controlEl.getAttribute('aria-expanded') === 'true';
    controlEl.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    controlEl.classList.toggle('is-open', !isOpen);
    panel.classList.toggle('harvest-bank-table__detail--closed', isOpen);
    if (panel.tagName !== 'TR') {
      panel.hidden = isOpen;
    }
  }
}
